import React from "react";
import "./how-to-get-rewarded.styles.css";
import {Col, Row} from "antd";
import wowSquareSmall from "../../../assets/images/wowSquareSmall.png"
import iOSAppStore from "../../../assets/images/iOSAppStore.svg"
import GooglePlay from "../../../assets/images/GooglePlay.svg"
import {useMediaQuery} from "react-responsive";

const Downlaod = () => {

    const isMobile = useMediaQuery({query: "(max-width: 560px)"});
    return isMobile ? ( <Row style={{textAlign: "center", justifyContent: "center"}}>
        
        <div
                className="mobileCarousalPublicStatic"
                style={{marginLeft: "3vw"}}
                slidesToShow={1}
                dots={true}
                autoplay={false}
            >
    <Col span={24} style={{marginTop: "5px"}}>
        {<img src={wowSquareSmall}/>}
        <span style={{paddingLeft: "5px", fontWeight: "750"}}>Download WOW</span>
    </Col>
    <Col span className="ios">
        {<img src={iOSAppStore}/>}
    </Col>

    <Col span className="ios">
        {<img src={GooglePlay}/>}
    </Col>

    </div>

</Row>
):
    
    ( 
        
        <Row style={{textAlign: "center", justifyContent: "center"}}>
    <Col span={4} style={{marginTop: "5px"}}>
        {<img src={wowSquareSmall}/>}
        <span style={{paddingLeft: "5px", fontWeight: "700"}}>Download WOW</span>
    </Col>
    <Col span={4} style={{paddingRight: "35px"}}>
        {<img src={iOSAppStore}/>}
    </Col>
    
    <Col span={4} style={{paddingRight: "35px"}}>
        {<img src={GooglePlay}/>}
    </Col>
</Row>);};
    
       
   


export default Downlaod;
